// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmergencyBranchUI_view__8HPHm{
  height: 100%;
  display: flex;
  flex-direction: column;
}

.EmergencyBranchUI_containerForm__NLiTJ{
  border: 1px solid var(--gray);
  width: 100%;
  max-width: 600px;
  padding: 15px;
}

.EmergencyBranchUI_title__m59Y9 {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.EmergencyBranchUI_label__4aLrg {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}

.EmergencyBranchUI_input__6Lohk,
.EmergencyBranchUI_input__6Lohk .ant-select-selector {
  background-color: #fbfbfb !important;
  border-color: #d2d2d2 !important;
  border-radius: 4px !important;
}

.EmergencyBranchUI_submit__R3Aom {
  width: 250px;
  font-weight: 700;
  font-size: 13px;
}

.EmergencyBranchUI_tableLabel__TsF\\+P{
  display: flex;
  gap:10px;
  margin:20px 0px ;
}

.EmergencyBranchUI_loader__AV1Fe {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.EmergencyBranchUI_actions__dhY4S {
  display: flex;
  align-items: center;
  justify-content: center;
  gap:10px;
}

.EmergencyBranchUI_actions__dhY4S svg{
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/emergency-branch/styles/EmergencyBranchUI.module.css"],"names":[],"mappings":"AAAA;EACI,YAAY;EACZ,aAAa;EACb,sBAAsB;AAC1B;;AACA;EACI,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,aAAa;AACjB;;AAEA;EACI,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEA,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACI,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAED;EACC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".view{\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n.containerForm{\n    border: 1px solid var(--gray);\n    width: 100%;\n    max-width: 600px;\n    padding: 15px;\n}\n\n.title {\n    color: var(--darkGray);\n    font-family: BebasNeue;\n    font-weight: 700;\n    font-size: 20px;\n  }\n  \n  .label {\n    font-weight: 500;\n    color: var(--darkGray);\n    font-size: 12px;\n  }\n\n  .input,\n.input :global(.ant-select-selector) {\n  background-color: #fbfbfb !important;\n  border-color: #d2d2d2 !important;\n  border-radius: 4px !important;\n}\n\n.submit {\n    width: 250px;\n    font-weight: 700;\n    font-size: 13px;\n  }\n  .tableLabel{\n    display: flex;\n    gap:10px;\n    margin:20px 0px ;\n  }\n\n .loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap:10px;\n}\n\n.actions svg{\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `EmergencyBranchUI_view__8HPHm`,
	"containerForm": `EmergencyBranchUI_containerForm__NLiTJ`,
	"title": `EmergencyBranchUI_title__m59Y9`,
	"label": `EmergencyBranchUI_label__4aLrg`,
	"input": `EmergencyBranchUI_input__6Lohk`,
	"submit": `EmergencyBranchUI_submit__R3Aom`,
	"tableLabel": `EmergencyBranchUI_tableLabel__TsF+P`,
	"loader": `EmergencyBranchUI_loader__AV1Fe`,
	"actions": `EmergencyBranchUI_actions__dhY4S`
};
export default ___CSS_LOADER_EXPORT___;
